import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const setData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_DEALERS_COUNTRIES_SUCCESS]: setData,
});
